import { i18n } from '../i18n/i18n'

import React, { Component } from 'react'
import { RouteComponentProps, withRouter } from 'react-router-dom'
import routes from '../routes/routes'
import userService from '../services/user.service'
import userApi, { UserData } from '../apis/user.api'
import { ActionName } from '../components/Actions'
import Card from '../components/Card'
import ContentLayout from '../components/ContentLayout'
import ContentMain from '../components/ContentMain'
import TableHorizontal, {
  TableHorizontalData,
  TableHorizontalHeader
} from '../components/TableHorizontal'
import HeadingRow from '../components/HeadingRow'
import Button from '../components/Button'
import storageService from '../services/storage.service'
import {useUserPlan} from "../utils/userPlan.util";

interface Props extends RouteComponentProps {
}

interface State {
    users: TableHorizontalData<UserData>[]
}

class Users extends Component<Props, State> {
  headers: TableHorizontalHeader[] = [
    { heading: i18n('Username'), path: 'username' },
    { heading: i18n('Timeout'), path: 'timeout' },
    {
      heading: i18n('Permissions'),
      path: 'permissionNames',
      tooltip: ['permissionNames'],
      truncate: true
    },
    {
      heading: i18n('Created at'),
      path: 'createdAt',
      date: true,
      tooltip: ['createdUser.username']
    },
    {
      heading: i18n('Updated at'),
      path: 'updatedAt',
      date: true,
      tooltip: ['updatedUser.username']
    },
    { heading: i18n('Actions') }
  ]

  constructor (props: Props) {
    super(props)
    this.state = {
      users: []
    }
    this.handleCreateClick = this.handleCreateClick.bind(this)
    this.handleActionClick = this.handleActionClick.bind(this)
  }

  handleActionClick (id: number, action: ActionName) {
    if (action === 'edit') {
      const pathname = routes.userEdit
      const state = { id }
      this.props.history.push({ pathname, state })
    } else if (action === 'resume') {
      userApi.block(id, user => {
        if (!user) return
        const users = userService.block(this.state.users, id)
        this.setState({ users })
      })
    } else if (action === 'start') {
      userApi.unblock(id, user => {
        if (!user) return
        const users = userService.unblock(this.state.users, id)
        this.setState({ users })
      })
    }
  }

  handleCreateClick () {
    this.props.history.push(routes.userCreate)
  }

  listUsers () {
    userApi.list('', users => {
      if (!users) return
      const usersData = userService.tableHorizontalData(users, false)
      this.setState({ users: usersData })
      storageService.set('userCount', users.length)
    })
  }

  componentDidMount () {
    this.listUsers()
  }

  render () {
    const {isAdvanced, isCustom, userCount} = useUserPlan();

    return (
            <ContentLayout>
                <ContentMain layout="full">
                    <Card>
                        <HeadingRow
                            heading={i18n('Users')}
                            doc='users'>

                          {
                            isCustom || (isAdvanced && userCount < 3) &&
                              <Button
                                  text={i18n('Create')}
                                  onClick={this.handleCreateClick}/>
                          }


                        </HeadingRow>
                        <TableHorizontal
                            headers={this.headers}
                            data={this.state.users}
                            onActionClick={this.handleActionClick}/>
                    </Card>
                </ContentMain>
            </ContentLayout>
    )
  }
}

export default withRouter(Users)
